import { useTranslation } from 'next-i18next';
import { useQuery } from '@apollo/client';
import { PoliciesQuery, PolicyTypeEnum } from '@/graphql/types';
import { POLICIES_QUERY } from '@/graphql/queries';

export const usePolicies = (policyType: PolicyTypeEnum) => {
    const { i18n } = useTranslation(); // Translations

    const { data, loading, error } = useQuery<PoliciesQuery>(POLICIES_QUERY, {
        variables: {
            policyType: policyType,
        },
        context: { headers: { 'X-Language': i18n.language } },
        fetchPolicy: 'cache-and-network',
    });

    return { policies: data?.policies?.policies, loading, error };
};
